import { useRef } from "react";

import { getFocusElement, setFocusElement } from "../focus";

type UseRestoreFocusReturn = {
  restoreFocusElement: () => void;
  saveFocusElement: () => Element | null;
};

/**
 * Simple hook to save the element with focus so that it may be later restored.
 */

export const useRestoreFocus = (): UseRestoreFocusReturn => {
  const focusElement = useRef<Element | null>(null);

  return {
    restoreFocusElement,
    saveFocusElement,
  };

  function restoreFocusElement() {
    setFocusElement(focusElement.current as HTMLElement);
  }

  function saveFocusElement() {
    focusElement.current = getFocusElement();

    return focusElement.current;
  }
};
